import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Button, Card, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Poll from './polls/Poll';
import AddPoll from './polls/AddPoll';

export default function PollCard({ agenda }) {
  const [polls, setPolls] = useState([]); // State to store polls
  const params = useParams();
  const meetingId = params.meetingId;
  const url = process.env.REACT_APP_URL;
  const { user: authUser } = useSelector((state) => state.auth);

  const getPolls = useCallback(async () => {
    try {
      const response = await fetch(`${url}/polls/${meetingId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setPolls(data.map((poll) => poll._id)); // Store poll IDs
      } else {
        console.error('Failed to fetch polls:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching polls:', error);
    }
  }, [url, meetingId]);

  useEffect(() => {
    getPolls();
  }, [getPolls]);

  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Container>
      <Card id="assignments" className="mb-3 mt-3">
        <Card.Header onClick={toggleCollapse} style={{ cursor: 'pointer', paddingTop: '5px' }}>
          <Row className="header mb-2">
            <Col xs={11} lg={11} className="title">
              <h5>Meeting Polls</h5>
            </Col>
            <Col xs={1} lg={1}>
              <i className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
            </Col>
          </Row>
        </Card.Header>
        {!isCollapsed && (
          <>
            <Card.Body className="to-left">
              <Row>
                <Col>
                  {authUser?.user.acl === "Officer" &&
                    <AddPoll agenda={agenda} meetingId={meetingId} getPolls={getPolls} />
                  }
                  {polls.length > 0 ? (
                    polls.map((pollId) => (
                      <Poll key={pollId} pollId={pollId} getPolls={getPolls} />
                    ))
                  ) : (
                    <p>No polls available for this meeting.</p>
                  )}
                </Col>
              </Row>
              <Row>
                <Col className="text-center mt-3">
                  <Button variant="primary" onClick={getPolls} className="w-100">
                    Reload Polls <i className="bi bi-arrow-clockwise"></i>
                  </Button>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Row>
                <Col xs={12} lg={12}>
                  <p className="float-end">Meeting Polls</p>
                </Col>
              </Row>
            </Card.Footer>
          </>
        )}
      </Card>
    </Container>
  );
}